module.exports = __webpack_public_path__ + "img/van-der-mee.6e4b078e.jpg";